export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11507.eba3c6f6.jpg";